export default __webpack_public_path__ + "static/media/upload-book-gold.2c15b13e.svg";